import React from 'react';
import classNames from 'classnames';
import './WingBlank.less';

function WingBlank({className, children, ...props}) {
  return (
    <div className={classNames('WingBlank', className)} {...props}>
      <div>
        {children}
      </div>
    </div>
  );
}

export default WingBlank;


// WEBPACK FOOTER //
// ./src/components/WingBlank/WingBlank.js